import { Button, Modal, message } from "antd";
import { useEffect, useState } from "react";
import * as S from "./styles";

export const UpdateQuestionModal = ({
  open,
  onCancel,
  onSubmit,
  selectedQuestion,
}) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [options, setOptions] = useState(['']);
  const [isMultipleChoice, setIsMultipleChoice] = useState(true);

  // Inicializa os estados com os dados da pergunta selecionada
  useEffect(() => {
    if (selectedQuestion) {
      setOptions(selectedQuestion.options?.length ? selectedQuestion.options : ['']);
    }

  }, [selectedQuestion]);

  const handleAddOption = () => {
    setOptions([...options, '']);
  };

  const handleRemoveOption = (index) => {
    const newOptions = options.filter((_, i) => i !== index);
    setOptions(newOptions);
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingSubmit(true);

      const formData = new FormData(e.currentTarget);
      const question = formData.get("question")?.toString();
      
      const validOptions = isMultipleChoice 
        ? options.filter(option => option.trim() !== '')
        : [];

      if (isMultipleChoice && validOptions.length < 2) {
        throw new Error("Perguntas devem ter pelo menos 2 opções de justificativa");
      }


      await onSubmit({
        question,
        options: validOptions,
        isMultipleChoice: true,
      });
    } catch (error) {
      console.error("failed to update question", error);
      message.error(error.message);
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <Modal
      title="Atualizar Pergunta"
      open={open}
      onCancel={onCancel}
      cancelText="Cancelar"
      destroyOnClose={true}
      closable={false}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
      width={600}
    >
      <S.Container onSubmit={handleSubmit}>
        <textarea
          name="question"
          placeholder="Nova Pergunta"
          rows={4}
          maxLength={200}
          defaultValue={selectedQuestion?.question}
          required
        />
        

        {isMultipleChoice && (
          <div className="options-container">
            <h4>Opções de justificativa:</h4>
            {options.map((option, index) => (
              <div key={index} className="option-row">
                <input
                  type="text"
                  value={option}
                  onChange={(e) => handleOptionChange(index, e.target.value)}
                  placeholder={`Opção ${index + 1}`}
                  required
                />
                {options.length > 1 && (
                  <Button 
                    type="text" 
                    danger 
                    onClick={() => handleRemoveOption(index)}
                  >
                    Remover
                  </Button>
                )}
              </div>
            ))}
            
            <Button type="dashed" onClick={handleAddOption} style={{ marginTop: 8 }}>
              + Adicionar Opção
            </Button>
          </div>
        )}

        <Button
          type="primary"
          htmlType="submit"
          disabled={loadingSubmit}
          id="app-button"
        >
          {loadingSubmit ? "Carregando..." : "Atualizar"}
        </Button>
      </S.Container>
    </Modal>
  );
};
